<!--提单管理  -->
<template>
  <div class="bill_of_lading" v-loading="loading">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 待审核 -->
      <el-tab-pane label="待审核" name="first">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="状态" min-width="100">
            <template slot-scope="scope">
              <div
                v-if="
                  $cookies.get('auth_grade') == 30 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                <el-tag
                  v-if="scope.row.agent_is_deal === 2"
                  type="success"
                  size="small"
                  >通过</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === ''"
                  type
                  size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === 1"
                  type="warning"
                  size="small"
                  >正在审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === 3"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('parent_agent_id') != null &&
                  $cookies.get('agent_company_name') != null
                "
              >
                <el-tag
                  v-if="scope.row.province_agent_is_deal === 2"
                  type="success"
                  size="small"
                  >通过</el-tag
                >

                <el-tag
                  v-else-if="scope.row.province_agent_is_deal === 1"
                  type="warning"
                  size="small"
                  >正在审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.province_agent_is_deal === 3"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
                <el-tag v-else type size="small">未提交</el-tag>
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                <el-tag
                  v-if="scope.row.is_money_back === 1"
                  type="success"
                  size="small"
                  >通过</el-tag
                >
                <el-tag
                  v-else-if="
                    scope.row.agent_is_deal === 2 &&
                    scope.row.is_money_back === null
                  "
                  type
                  size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="
                    scope.row.is_money_back === '' ||
                    scope.row.is_money_back === null
                  "
                  type
                  size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="scope.row.is_money_back === 0"
                  type="warning"
                  size="small"
                  >正在审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.is_money_back === 2"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
              </div>
              <div
                v-else-if="
                  $cookies.get('agent_company_name') != null &&
                  $cookies.get('auth_grade') == 20
                "
              >
                <el-tag
                  v-if="scope.row.agent_is_deal === 2"
                  type="success"
                  size="small"
                  >通过</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === ''"
                  type
                  size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === 1"
                  type="warning"
                  size="small"
                  >正在审核</el-tag
                >
                <el-tag
                  v-else-if="scope.row.agent_is_deal === 3"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
              </div>
              <div v-else>
                <el-tag
                  v-if="scope.row.is_money_back === 1"
                  type="success"
                  size="small"
                  >通过</el-tag
                >

                <el-tag
                  v-else-if="
                    scope.row.is_money_back === 0 &&
                    scope.row.sale_person_id != ''
                  "
                  type="warning"
                  size="small"
                  >正在审核</el-tag
                >
                <el-tag v-else-if="scope.row.sale_person_id == ''" size="small"
                  >未提交</el-tag
                >
                <el-tag
                  v-else-if="scope.row.is_money_back === 2"
                  type="danger"
                  size="small"
                  >被驳回</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="opened_account"
            label="开通账户"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="client_name"
            label="客户姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="client_phone"
            label="客户手机"
            min-width="100"
          ></el-table-column>
          <!-- <el-table-column prop="client_wx" label="客户微信" min-width="100"></el-table-column> -->
          <el-table-column
            prop="client_source"
            label="客户来源"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="company_name"
            label="公司名称"
            min-width="100"
          ></el-table-column>
          <el-table-column label="公司地址" min-width="100">
            <template slot-scope="scope">
              {{ scope.row.place_name.city_name
              }}{{ scope.row.place_name.district_name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="industry_name"
            label="公司行业"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="deal_product"
            label="产品套餐"
            min-width="100"
          ></el-table-column>
          <el-table-column prop="money_back" label="合同金额"></el-table-column>
          <el-table-column
            prop=""
            label="结算金额"
            min-width="120px"
            v-if="$cookies.get('auth_grade') >= 80"
          >
            <template slot-scope="scope">
              <div
                v-if="
                  ($cookies.get('auth_grade') == 80 &&
                    $cookies.get('parent_agent_id') == null) ||
                  $cookies.get('auth_grade') == 90
                "
              >
                {{ scope.row.agent_money_back }}
              </div>
              <div v-else>
                {{
                  scope.row.province_agent_money_back == 0
                    ? ""
                    : scope.row.province_agent_money_back
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            min-width="90px"
            v-if="$cookies.get('auth_grade') != 80"
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.is_money_back != 0 || scope.row.agent_is_deal != 1
                "
                type="primary"
                size="small"
                @click="submit(scope.row, '提交', '提交')"
                >提交</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            min-width="150px"
            v-if="$cookies.get('auth_grade') == 80"
          >
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="showTable(scope.row)"
                >修改</el-button
              >
              <el-button
                v-if="
                  scope.row.is_money_back != 0 || scope.row.agent_is_deal != 1
                "
                type="primary"
                size="mini"
                @click="submit(scope.row, '提交', '提交')"
                >提交</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="sale_people_name"
            label="销售人"
            v-if="$cookies.get('auth_grade') != 30"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
          ></el-table-column>
          <el-table-column label="提单凭证" min-width="80px" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" trigger="click">
                <div class="scopeDiv">
                  <div>
                    <p>合同照片</p>
                    <el-image
                      v-if="scope.row.contract_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.contract_img == []
                          ? ''
                          : scope.row.contract_img[0]
                      "
                      :preview-src-list="scope.row.contract_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>合同打款照片</p>
                    <el-image
                      v-if="scope.row.money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.money_back_img == []
                          ? ''
                          : scope.row.money_back_img[0]
                      "
                      :preview-src-list="scope.row.money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') >= 80">
                    <p>代理商结算照片</p>
                    <el-image
                      v-if="scope.row.agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.agent_money_back_img.length == 0
                          ? ''
                          : scope.row.agent_money_back_img[0]
                      "
                      :preview-src-list="scope.row.agent_money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') >= 90">
                    <p>省代结算照片</p>
                    <el-image
                      v-if="scope.row.province_agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.province_agent_money_back_img == []
                          ? ''
                          : scope.row.province_agent_money_back_img[0]
                      "
                      :preview-src-list="
                        scope.row.province_agent_money_back_img
                      "
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>营业执照照片</p>
                    <el-image
                      v-if="scope.row.business_license_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.business_license_img[0] == []
                          ? ''
                          : scope.row.business_license_img[0]
                      "
                      :preview-src-list="scope.row.business_license_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                </div>
                <el-button slot="reference" type="text">查看详情</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="province_agent_check_remarks"
            label="审核备注"
            min-width="100"
            v-if="
              $cookies.get('auth_grade') == 80 &&
              $cookies.get('parent_agent_id') != null
            "
          >
            <template slot-scope="scope">
              <div
                v-if="
                  $cookies.get('auth_grade') == 30 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.agent_is_deal === 3
                    ? scope.row.province_agent_check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('parent_agent_id') != null &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.province_agent_is_deal === 3
                    ? scope.row.province_agent_check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.is_money_back === 2
                    ? scope.row.province_agent_check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('agent_company_name') != null &&
                  $cookies.get('auth_grade') == 20
                "
              >
                {{
                  scope.row.agent_is_deal === 3
                    ? scope.row.province_agent_check_remarks
                    : ""
                }}
              </div>
              <div v-else>
                {{
                  scope.row.is_money_back === 2
                    ? scope.row.province_agent_check_remarks
                    : ""
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="agent_check_remarks"
            label="审核备注"
            min-width="100"
            v-else-if="
              $cookies.get('auth_grade') == 20 &&
              $cookies.get('agent_company_name') != null
            "
          >
            <template slot-scope="scope">
              <div
                v-if="
                  $cookies.get('auth_grade') == 30 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.agent_is_deal === 3
                    ? scope.row.agent_check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('parent_agent_id') != null &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.province_agent_is_deal === 3
                    ? scope.row.agent_check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.is_money_back === 2
                    ? scope.row.agent_check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('agent_company_name') != null &&
                  $cookies.get('auth_grade') == 20
                "
              >
                {{
                  scope.row.agent_is_deal === 3
                    ? scope.row.agent_check_remarks
                    : ""
                }}
              </div>
              <div v-else>
                {{
                  scope.row.is_money_back === 2
                    ? scope.row.agent_check_remarks
                    : ""
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="check_remarks"
            label="审核备注"
            min-width="100"
            v-else
          >
            <template slot-scope="scope">
              <div
                v-if="
                  $cookies.get('auth_grade') == 30 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.agent_is_deal === 3 ? scope.row.check_remarks : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('parent_agent_id') != null &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.province_agent_is_deal === 3
                    ? scope.row.check_remarks
                    : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('auth_grade') == 80 &&
                  $cookies.get('agent_company_name') != null
                "
              >
                {{
                  scope.row.is_money_back === 2 ? scope.row.check_remarks : ""
                }}
              </div>
              <div
                v-else-if="
                  $cookies.get('agent_company_name') != null &&
                  $cookies.get('auth_grade') == 20
                "
              >
                {{
                  scope.row.agent_is_deal === 3 ? scope.row.check_remarks : ""
                }}
              </div>
              <div v-else>
                {{
                  scope.row.is_money_back === 2 ? scope.row.check_remarks : ""
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="提交">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="small"
                v-if="
                  $cookies.get('auth_grade') == 90 &&
                  scope.row.is_money_back == 2
                "
                @click="withdrawal(scope.row)"
                >撤回</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- //已成交 -->
      <el-tab-pane label="已成交" name="second" style="width: 100%">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="opened_account"
            label="开通账户"
          ></el-table-column>

          <el-table-column
            prop="client_name"
            label="客户姓名"
          ></el-table-column>
          <el-table-column
            prop="client_phone"
            label="客户手机"
          ></el-table-column>
          <!-- <el-table-column prop="client_wx" label="客户微信"></el-table-column> -->
          <el-table-column
            prop="client_source"
            label="客户来源"
          ></el-table-column>
          <el-table-column
            prop="company_name"
            label="公司名称"
          ></el-table-column>

          <el-table-column label="公司地址">
            <template slot-scope="scope">
              {{ scope.row.place_name.city_name
              }}{{ scope.row.place_name.district_name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="industry_name"
            label="公司行业"
          ></el-table-column>

          <el-table-column
            prop="deal_product"
            label="产品套餐"
          ></el-table-column>

          <el-table-column
            prop="sale_people_name"
            label="销售人 "
            v-if="$cookies.get('auth_grade') != 30"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
          ></el-table-column>
          <el-table-column prop="money_back" label="合同金额"></el-table-column>
          <el-table-column
            prop
            label="结算金额"
            min-width="120px"
            v-if="$cookies.get('auth_grade') >= 80"
          >
            <template slot-scope="scope">
              <div
                v-if="
                  ($cookies.get('auth_grade') == 80 &&
                    $cookies.get('parent_agent_id') == null) ||
                  $cookies.get('auth_grade') == 90
                "
              >
                {{ scope.row.agent_money_back }}
              </div>
              <div v-else>
                {{
                  scope.row.province_agent_money_back == 0
                    ? ""
                    : scope.row.province_agent_money_back
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="提单凭证" min-width="80px" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" trigger="click">
                <div class="scopeDiv">
                  <div>
                    <p>合同照片</p>
                    <el-image
                      v-if="scope.row.contract_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.contract_img == []
                          ? ''
                          : scope.row.contract_img[0]
                      "
                      :preview-src-list="scope.row.contract_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div>
                    <p>合同打款照片</p>
                    <el-image
                      v-if="scope.row.money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.money_back_img == []
                          ? ''
                          : scope.row.money_back_img[0]
                      "
                      :preview-src-list="scope.row.money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') >= 80">
                    <p>代理商结算照片</p>
                    <el-image
                      v-if="scope.row.agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.agent_money_back_img == []
                          ? ''
                          : scope.row.agent_money_back_img[0]
                      "
                      :preview-src-list="scope.row.agent_money_back_img"
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                  <div v-if="$cookies.get('auth_grade') >= 90">
                    <p>省代结算照片</p>
                    <el-image
                      v-if="scope.row.province_agent_money_back_img.length != 0"
                      style="width: 80px; height: 80px"
                      :src="
                        scope.row.province_agent_money_back_img == []
                          ? ''
                          : scope.row.province_agent_money_back_img[0]
                      "
                      :preview-src-list="
                        scope.row.province_agent_money_back_img
                      "
                    ></el-image>
                    <div v-else class="D_div">无</div>
                  </div>
                </div>
                <el-button slot="reference" type="text">查看详情</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="续费" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="warning"
                v-if="
                  scope.row.is_money_back == 1 &&
                  $cookies.get('auth_grade') == 80
                "
                size="mini"
                @click="submit(scope.row, '提交', '续费')"
                >续费</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- //提交按钮提示框 -->
    <el-dialog
      :title="title"
      :visible.sync="is_submit"
      width="30%"
      :before-close="handleClose"
      @close="closeClick"
    >
      <el-form ref="form" :model="from" label-width="80px" :rules="rules">
        <el-form-item
          label="结算金额"
          :required="true"
          v-if="
            $cookies.get('auth_grade') == 80 || $cookies.get('auth_grade') == 90
          "
        >
          <el-input
            v-model="from.agent_money_back"
            placeholder="请输入结算金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照" :required="true">
          <el-upload
            class="avatar-uploader"
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :on-success="success_zhizhao"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-form ref="form" :model="from" label-width="90px" :rules="rules">
        <el-form-item label="开通账户" prop="name">
          <el-input
            v-model="from.name"
            placeholder="请输入开通账户"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="公司名称"
          prop="company_names"
          v-if="
            title == '提交' &&
            (($cookies.get('auth_grade') == 20 &&
              $cookies.get('agent_company_name')) ||
              ($cookies.get('auth_grade') == 80 &&
                $cookies.get('agent_company_name')))
          "
        >
          <el-input
            v-model.trim="company_names"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同金额" prop="money">
          <el-input
            v-model="from.money"
            placeholder="请输入合同金额"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品套餐" prop="meal">
          <el-input
            v-model="from.meal"
            placeholder="请输入套餐（季度版、半年版、年度版）"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="省代结算"
          required
          v-if="$cookies.get('auth_grade') >= 90"
        >
          <el-upload
            class="avatar-uploader"
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :on-success="success_P_p"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="success_P_pArr" :src="success_P_pArr" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="代理商结算"
          required
          v-if="$cookies.get('auth_grade') >= 80"
        >
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="success_agent_p"
          >
            <img
              v-if="success_agent_pArr"
              :src="success_agent_pArr"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="合同打款证明" required>
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :on-success="imgSuccess_payment"
          >
            <img v-if="paymentArr" :src="paymentArr" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="合同照片" required>
          <span style="color: #f00; font-size: 12px">最多上传三张</span>
          <el-upload
            :action="url_Api + '/hr24_user/v1/upload_file/'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove_img"
            :file-list="imgArr"
            :on-success="imgSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item
          label="用户所在地区"
          v-if="
            title == '提交' &&
            (($cookies.get('auth_grade') == 20 &&
              $cookies.get('agent_company_name')) ||
              ($cookies.get('auth_grade') == 80 &&
                $cookies.get('agent_company_name')))
          "
          prop="company_place"
          ><el-cascader
            class="input"
            v-model="company_place"
            :options="place_list"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="用户所在行业"
          v-if="
            title == '提交' &&
            (($cookies.get('auth_grade') == 20 &&
              $cookies.get('agent_company_name')) ||
              ($cookies.get('auth_grade') == 80 &&
                $cookies.get('agent_company_name')))
          "
          prop="industry"
        >
          <!-- 获取的options值不是那种{value:'',label:''}格式，就需要自己定义利用props -->
          <el-cascader
            class="input"
            v-model="industry"
            :options="industry_data"
            :props="{ value: 'industry_id', label: 'name' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item v-if="title == '续费'" label="开始时间">
          <el-date-picker
            v-model="renew_start_time"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="title == '续费'" label="结束时间">
          <el-date-picker
            v-model="renew_end_time"
            value-format="timestamp"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              from = {};
              imgArr = [];
              imgData = [];
              paymentData = '';
              paymentArr = '';
              success_agent_pArr = '';
              success_agent_pData = '';
              success_P_pArr = '';
              success_P_pData = '';
              license = '';
              // 展示图片变量
              imageUrl = '';
              is_submit = false;
            }
          "
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitYes"
          :disabled="is_admin_deal_list"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- //提交按钮提示框 -->
    <el-dialog
      :title="tit"
      :visible.sync="is_reject"
      width="30%"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        :rows="4"
        :placeholder="'请输入' + tit + '理由'"
        maxlength="250"
        :show-word-limit="true"
        v-model="textarea"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shenHe(2)">不通过</el-button>
        <el-button type="primary" @click="shenHe(1)">通过</el-button>
      </span>
    </el-dialog>
    <div class="page">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="total"
        :page-size="15"
        @current-change="pageChange"
      ></el-pagination>
    </div>
    <el-drawer
      title="修改"
      size="800"
      :visible.sync="dialog"
      :with-header="false"
      :before-close="
        () => {
          this.city_cascader_focus();
          this.dialog = false;
        }
      "
    >
      <div class="detail_info">
        <div>
          <!-- title -->
          <div class="nav_title">
            <div>
              <i
                @click="close"
                class="iconfont iconLC_icon_close_fill_circle"
              ></i>
            </div>
            <div>{{ client_name }}</div>
          </div>

          <div class="rl_flex">
            <!-- 概况 -->
            <div class="nav_left">
              <!-- 客户总体概览 -->
              <div>
                <div>
                  <div class="over_title">基本信息</div>
                  <div class="half_fl">
                    <div v-for="(item, index) in basic_info" :key="index">
                      <div class="title">{{ item.title }}</div>

                      <div v-if="item.select">
                        <el-select
                          @change="selectChange"
                          v-model="item.value"
                          placeholder="请选择活动区域"
                        >
                          <el-option
                            v-for="(item, index) in sex"
                            :key="index"
                            :label="item.title"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>

                      <!-- 未点击 在没有值是 显示点击输入  有值显示时显示值 -->
                      <div class="cont" v-else-if="item.isclick && item.input">
                        <el-input
                          focus
                          :placeholder="item.input"
                          v-model="item.value"
                          @blur="compile(item)"
                          type="text"
                        >
                          <i
                            @click="item.isclick = false"
                            slot="suffix"
                            class="el-input__icon el-icon-date"
                          ></i>
                        </el-input>
                      </div>
                      <div class="cont" v-else @click="item.isclick = true">
                        {{ item.value == null ? "点击输入" : item.value }}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="over_title">详细信息</div>
                  <div class="half_fl">
                    <div v-for="(item, index) in detail_info" :key="index">
                      <div class="title">{{ item.title }}</div>

                      <!--输入框 -->
                      <div v-if="item.input == 'text'" class="cont">
                        <div v-if="item.isclick" class="cont">
                          <el-input
                            :placeholder="item.placeholder"
                            v-model="item.value"
                            @blur="compile(item)"
                            type="text"
                          />
                        </div>
                        <div v-else @click="item.isclick = true">
                          {{ item.value == null ? "点击输入" : item.value }}
                        </div>
                      </div>

                      <div v-else-if="item.input == 'multi'" class="cont">
                        <el-cascader
                          v-model="item.value"
                          :options="place_data"
                          :props="place_props"
                          @change="placeChanged"
                        ></el-cascader>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require, url_Api } from "@/utils/http_request.js";
import axios from "axios";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      is_admin_deal_list: false,
      company_names: "",
      trues: true,
      company_place: [],
      place_list: [],
      industry: [],
      industry_data: [],
      loading: true,
      url_Api: "",
      activeName: "first",
      //表单数据
      tableData: [],
      title: "提交",
      is_submit: false,

      //提交按钮上传合同照片开始
      from: {
        name: "",
        money: "",
        meal: "",
      },
      dialogImageUrl: "",
      paymentImageUrl: "",
      paymentVisible: false,
      dialogVisible: false,
      disabled: false,
      imgArr: [],
      success_agent_pArr: "",
      success_P_pArr: "",
      success_agent_pData: "",
      success_P_pData: "",
      imgData: [], //存储合同上传的文件id
      paymentArr: "",
      paymentData: "", //存储回款上传的文件id
      rules: {
        name: [
          { required: true, message: "请输入开通账户", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            min: 11,
            max: 11,
            message: "请输入11位手机号",
            trigger: "change",
          },
          {
            pattern: /^\d+$/,
            message: "请输入数字",
            trigger: "change",
          },
        ],
        money: [
          { required: true, message: "请输入结算金额", trigger: "blur" },
          {
            pattern: /^\d+$/,
            message: "请输入数字",
            trigger: "change",
          },
        ],
        meal: [{ required: true, message: "请输入产品套餐", trigger: "blur" }],
      },
      //提交按钮上传合同照片结束
      //驳回按钮事件开始
      is_reject: false,
      textarea: "",
      sale_people: [],
      sale_people_id: "",
      total: 1, //分页总数
      tag_name: "0",
      client_id: "", //客户id
      page: 0,
      tit: "审核",
      keHuid: "", //存储客户id
      imageUrl: "",
      license: "",
      dialog: false,
      client_name: "",
      status: [],
      survey: [
        {
          title: "所属人员",
          cont: "北京三门课科技有限公司",
        },
        {
          title: "客户类型",
          value: "",
          type: "select",
        },
        {
          title: "下次跟进时间",
          type: "next_follow_time",
          value: null,
          isclick: false,
          input: "date",
        },
        {
          title: "下次出访时间",
          type: "visit_client_time_str",
          value: null,
          isclick: false,
          input: "date_item",
        },
      ],
      basic_info: [
        {
          type: "client_name",
          title: "姓名",
          input: "请输入姓名",
          value: null,
          isclick: false,
        },
        {
          type: "client_wx",
          title: "微信号",
          value: null,
          isclick: false,
          input: "请输入微信号",
        },
        {
          type: "client_phone",
          title: "电话",
          input: "请输入电话",
          value: null,
          isclick: false,
        },

        // {
        //   type: "client_gender",
        //   title: "性别",
        //   select: "sex",
        //   value: null,
        //   isclick: false
        // }
      ],

      detail_info: [
        {
          type: "client_source",
          title: "客户来源",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入客户来源",
        },
        {
          title: "公司名称",
          type: "company_name",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入公司名称",
        },
        {
          type: "area_id",
          title: "所在城市",
          value: null,
          isclick: false,
          input: "multi",
          options: "",
        },
        {
          title: "公司职位",
          type: "company_position",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入公司职位",
        },
        {
          title: "详细地址",
          type: "company_place_detail",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入详细地址",
        },

        {
          title: "备注",
          type: "com_remarks",
          value: null,
          isclick: false,
          input: "text",
          placeholder: "请输入备注",
        },
      ],
      place_data: [],
      place_props: {
        value: "province_code",
        label: "province_name",
        children: "children",
      },
      region_options: [
        {
          label: "不限",
          value: "",
        },
      ],
      status_id_dict: {},
      renew_start_time: "", //续费开始时间
      renew_end_time: "", //续费结束时间
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    closeClick() {
      this.$refs.form.resetFields();
    },
    //撤回提交
    withdrawal(data) {
      console.log(data);
      let is_tong = 0;
      this.$confirm(
        "是否执行此操作，驳回后会把提单撤回到代理商处，请谨慎操作！",
        "提示",
        {
          confirmButtonText: "撤回",
          cancelButtonText: "取消",
          distinguishCancelAndClose: true,
          type: "warning",
        }
      )
        .then((res) => {
          console.log("cvaghscvasghvcghas", res);
          is_tong = 3;
          require("post", "/lufish_sale/v1/province_audit_withdraw/", {
            deal_id: data.deal_id,
            province_agent_is_deal: is_tong,
          }).then((res) => {
            if (!res.code) {
              console.log("bbabaabab ");
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.init(this.page, this.tag_name);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch((action) => {
          // console.log(action);
          // if (action === "cancel") {
          //   is_tong = 3;
          //   require("post", "/lufish_sale/v1/province_audit_withdraw/", {
          //     deal_id: data.deal_id,
          //     province_agent_is_deal: is_tong,
          //   }).then((res) => {
          //     if (!res.code) {
          //       console.log("bbabaabab ");
          //       this.$message({
          //         message: res.msg,
          //         type: "success",
          //       });
          //       this.init(this.page, this.tag_name);
          //     } else {
          //       this.$message.error(res.msg);
          //     }
          //   });
          // }
        });
      // .catch(() => {

      // });
    },
    //行点击
    showTable(e) {
      console.log("aaaaa", e);
      console.log("aaaaa", e["area_id"]);
      e["area_id"] = [
        e.place_name.province_code + "",
        e.place_name.city_code + "",
        e.place_name.district_code + "",
      ];
      this.dialog = true;

      if (this.$cookies.get("agent_company_name") != null) {
        if (this.place_data[0].children[0].label == "不限") {
          this.place_data[0].children = this.place_data[0].children.filter(
            (item, index) => {
              return index != 0;
            }
          );
        }
      }
      this.show_client_id = e.client_id;
      this.staff_id = e.staff_id;
      this.client_name = e.client_name;
      this.client_id = e.client_id;
      this.status_id = this.status_id_dict[e.follow_status_id] || 0;
      this.survey[1].value = e.client_sort;
      console.log(e.place_name.district_code, "asc");
      //循环数据将数据进行 验证带入值
      for (let i in e) {
        this.record = e.follow_data;
        this.detail_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              if (i == "area_id") {
                console.log([
                  e.place_name.city_code + "",
                  e.place_name.district_code + "",
                ]);

                if (this.$cookies.get("agent_company_name") != null) {
                  item.value = [
                    e.place_name.city_code + "",
                    e.place_name.district_code + "",
                  ];
                } else {
                  item.value = e[i];
                }
              } else {
                item.value = e[i];
              }
            } else {
              item.value = "";
            }
          }
        });

        this.basic_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              item.value = e[i];
            } else {
              item.value = "";
            }
          }
        });
        this.survey.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              if (e[i] == "1970-01-01") {
                item.value = "";
              } else {
                item.value = e[i];
              }
            } else {
              item.value = "";
            }
          }
        });
      }
      console.log(this.detail_info, this.basic_info, this.survey, this.record);
    },
    close() {
      console.log("关闭");
      this.city_cascader_focus();
      this.dialog = false;
      this.init(this.page, this.tag_name);
    },
    compile(item) {
      item.isclick = false;
      let compile_obj = {};
      compile_obj[item.type] = item.value;
      this.compile_d(compile_obj);
    },
    city_cascader_focus() {
      if (this.$cookies.get("auth_grade") != null) {
        if (this.place_data[0].children[0].label != "不限") {
          this.place_data[0].children.unshift({
            label: "不限",
            value: this.place_data[0].value,
          });
        }
      }
    },
    placeChanged(e) {
      let compile_obj = {};

      if (this.$cookies.get("agent_company_name") != null) {
        compile_obj["company_place"] = e[1];
      } else {
        compile_obj["company_place"] = e[2];
      }
      this.compile_d(compile_obj);
    },
    compile_d(obj = {}) {
      console.log(obj);
      let follow_update = {
        label_code: "update",
        client_id: this.client_id,
        update_client: obj,
      };

      require("post", "/lufish_sale/v1/lufish_sale_client/", follow_update).then(
        (res) => {
          if (!res.code) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.init(this.page, this.tag_name);
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    saleChange(e) {
      let compile_obj = {};
      compile_obj["client_sort"] = e;
      this.compile_d(compile_obj);
    },
    success_zhizhao(file) {
      // 图片参数
      console.log(file);
      this.license = file.data.file_data.file_id;
      // 展示图片变量
      this.imageUrl = file.data.file_data.file_url;
      console.log(this.license);
    },
    beforeAvatarUpload(file) {
      //   const isJPG = file.type === "image/jpeg";
      const isLt10M = file.size / 1024 / 1024 < 10;
      //   if (!isJPG) {
      //     this.$message.error("上传头像图片只能是 JPG 格式!");
      //   }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt10M;
    },
    //标签点击
    handleClick(val) {
      this.tableData = [];
      console.log(val);
      this.loading = true;
      this.tag_name = val.index;
      this.tableData = [];
      if (val.label == "已成交") {
        this.init(0, 1);
      } else {
        this.init(0, 0);
      }
    },

    //分页
    pageChange(page) {
      console.log(page);
      this.page = page - 1;
      this.init(Number(page - 1), Number(this.tag_name));
    },
    //提交按钮
    submit(row, tijiao, xufei = "") {
      // this.trues = false;

      console.log(row);
      this.from = {};
      console.log(xufei);
      this.title = xufei;
      this.renew_start_time = "";
      this.renew_end_time = "";
      this.client_id = row.client_id;
      this.is_submit = true;
      let obj = {}; //字体回显
      let arrImg = []; //合同图片回显
      this.company_place = [];
      this.industry = [];
      if (this.$cookies.get("agent_company_name") != null && xufei == "提交") {
        // if (
        //   (this.$cookies.get('auth_grade') == 20 && row.agent_is_deal === 3) ||
        //   this.$cookies.get('auth_grade') == 80 ||
        //   this.$cookies.get('auth_grade') == 90
        // ) {
        obj = {
          name: row.opened_account || "",
          money: row.money_back || "",
          meal: row.deal_product || "",
        };
        if (
          (this.$cookies.get("auth_grade") == 20 &&
            this.$cookies.get("agent_company_name")) ||
          (this.$cookies.get("auth_grade") == 80 &&
            this.$cookies.get("agent_company_name"))
        ) {
          for (const key in row.place_name) {
            if (
              key == "city_code" ||
              key == "district_code" ||
              key == "province_code"
            ) {
              this.company_place.push(row.place_name[key]);
            }
          }
          if (this.company_place.length == 2) {
            this.company_place.unshift(this.company_place[0]);
          }
          this.industry_data.forEach((item, index) => {
            item.children.forEach((item1, index) => {
              if (item1.industry_id == row.industry) {
                this.industry.push(item.industry_id);
                this.industry.push(item1.industry_id);
              }
            });
          });
          this.company_names = row.company_name;
          // this.$nextTick(() => {
          //   this.trues = true;
          // });
        }
        if (row.contract_img.length > 0) {
          row.contract_img.forEach((item, index) => {
            arrImg.push({
              name: item,
              url: item,
              uid: row.contract_img_id.split(",")[index],
            });
          });
          this.imgArr = arrImg;
          this.imgData = row.contract_img_id.split(",");
        } else {
          this.imgData = [];
          this.imgData = [];
        }
        if (row.money_back_img.length > 0) {
          this.paymentArr = row.money_back_img[0] || "";
          this.paymentData = row.money_back_img_id || "";
        } else {
          this.paymentArr = "";
          this.paymentData = [];
        }
        if (row.agent_money_back_img.length > 0) {
          this.success_agent_pArr = row.agent_money_back_img[0] || "";
          this.success_agent_pData = row.agent_money_back_img_id || "";
        } else {
          this.success_agent_pArr = "";
          this.success_agent_pData = "";
        }
        if (row.province_agent_money_back_img.length > 0) {
          this.success_P_pArr = row.province_agent_money_back_img[0];
          this.success_P_pData = row.province_agent_money_back_img_id;
        } else {
          this.success_P_pArr = "";
          this.success_P_pData = "";
        }
        // }
        if (row.business_license_img.length > 0) {
          this.imageUrl = row.business_license_img[0];
          this.license = row.business_license_img_id || "";
        }
        if (
          this.$cookies.get("auth_grade") == 80 &&
          this.$cookies.get("parent_agent_id") == null
        ) {
          obj.agent_money_back =
            row.agent_money_back == 0 ? "" : row.agent_money_back;
        } else if (
          this.$cookies.get("auth_grade") == 80 &&
          this.$cookies.get("parent_agent_id") != null
        ) {
          obj.agent_money_back =
            row.province_agent_money_back == 0
              ? ""
              : row.province_agent_money_back;
        } else if (this.$cookies.get("auth_grade") == 90) {
        }
      } else {
        obj = {
          name: row.opened_account || "",
        };
        if (row.business_license_img.length > 0) {
          this.imageUrl = row.business_license_img[0];
          this.license = row.business_license_img_id || "";
        }
      }

      this.from = obj;
      console.log(typeof obj.money);
    },
    //提交按钮涉及的事件开始
    imgSuccess(response) {
      console.log(response);

      //合同图片上传成功
      if (response.code == 0) {
        this.imgData.push(response.data.file_data.file_id);
      }
      console.log(this.imgData);
    },
    handleRemove_img(file) {
      if (file.response) {
        this.imgData = this.imgData.filter((item, index) => {
          return item != file.response.data.file_data.file_id;
        });
      } else {
        this.imgData = this.imgData.filter((item, index) => {
          return item != file.uid;
        });
      }

      console.log(this.imgData);
    },
    imgSuccess_payment(response) {
      //销售图片上传成功
      if (response.code == 0) {
        this.paymentData = response.data.file_data.file_id;
        this.paymentArr = response.data.file_data.file_url;
      }
      console.log(this.paymentData);
    },
    success_agent_p(response) {
      console.log(response);
      //代理商图片上传成功
      if (response.code == 0) {
        this.success_agent_pData = response.data.file_data.file_id;
        this.success_agent_pArr = response.data.file_data.file_url;
      }
      console.log(this.success_agent_pArr);
    },
    success_P_p(response) {
      //合同图片上传成功
      console.log(response);
      if (response.code == 0) {
        this.success_P_pData = response.data.file_data.file_id;
        this.success_P_pArr = response.data.file_data.file_url;
      }
      console.log(this.paymentData);
    },
    handleRemove_payment(file) {
      //销售合同证明删除
      console.log(this.paymentData);
      console.log(this.paymentArr);
      if (file.response) {
        this.paymentData = this.paymentData.filter((item, index) => {
          return item != file.response.data.file_data.file_id;
        });
      } else {
        this.paymentData = this.paymentData.filter((item, index) => {
          return item != file.uid;
        });
      }

      console.log(this.paymentData);
    },
    handlePictureCardPreview(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    //提交确定按钮
    submitYes() {
      console.log(this.from.money);
      console.log(this.imgData, this.paymentData);
      console.log(typeof this.from.name);
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
      });

      if (JSON.stringify(this.from) == "{}") {
        this.$message({
          type: "error",
          message: "请填写必填项",
        });
        return false;
      }
      if (
        this.title == "提交" &&
        ((this.$cookies.get("auth_grade") == 20 &&
          this.$cookies.get("agent_company_name")) ||
          (this.$cookies.get("auth_grade") == 80 &&
            this.$cookies.get("agent_company_name")))
      ) {
        if (!this.company_names) {
          this.$message({
            type: "error",
            message: "请填写公司名称",
          });
          return false;
        }
        if (this.company_place.length == 0) {
          this.$message({
            type: "error",
            message: "请选择用户所在地",
          });
          return false;
        }
        if (this.industry.length == 0) {
          this.$message({
            type: "error",
            message: "请选择用户所在行业",
          });
          return false;
        }
      }

      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 90
      ) {
        console.log(this.from.agent_money_back);
        if (
          this.from.agent_money_back == "" ||
          this.from.agent_money_back == undefined
        ) {
          this.$message({
            type: "error",
            message: "请填写结算金额",
          });
          return false;
        }
      }
      if (this.license == "") {
        this.$message({
          type: "error",
          message: "请上传营业执照",
        });
        return false;
      }

      if (this.imgData.length == 0) {
        this.$message({
          type: "error",
          message: "请上传合同照片",
        });
        return false;
      }
      if (this.from.name == "") {
        this.$message({
          type: "error",
          message: "请填写开通账户",
        });
        return false;
      }

      if (this.from.name.length != 11) {
        this.$message({
          type: "error",
          message: "请填写正确的账户",
        });
        return false;
      }

      //
      if (this.from.money == "" || this.from.money == undefined) {
        this.$message({
          type: "error",
          message: "请填写合同金额",
        });
        return false;
      }
      if (this.paymentData == "") {
        this.$message({
          type: "error",
          message: "请上传合同打款证明",
        });
        return false;
      }
      if (
        this.success_agent_pData == "" &&
        this.$cookies.get("auth_grade") >= 80
      ) {
        this.$message({
          type: "error",
          message: "请上传代理商结算",
        });
        return false;
      }
      if (this.success_P_pData == "" && this.$cookies.get("auth_grade") >= 90) {
        this.$message({
          type: "error",
          message: "请上传代理商结算",
        });
        return false;
      }
      if (!this.from.meal) {
        this.$message({
          type: "error",
          message: "请填写产品套餐",
        });
        return false;
      }
      let obj = {
        create_data: {
          client_id: this.client_id,
          deal_product: this.from.meal,
          money_back: this.from.money,
          contract_img: this.imgData.join(","),
          money_back_img: this.paymentData || "",
          agent_money_back_img: this.success_agent_pData || "",
          province_agent_money_back_img: this.success_P_pData || "",
          opened_account: this.from.name,
        },
        business_license_img: this.license,
      };
      if (this.title == "续费") {
        // if (!this.renew_start_time && !this.renew_end_time) {
        //   this.$message.warning("请选择续费日期");
        //   return false;
        // }
        obj.is_renew = 1; //# 是否续费
        obj.renew_data = {
          renew_start_time: this.renew_start_time / 1000,
          renew_end_time: this.renew_end_time / 1000,
        }; // # 续费数据
        // obj.staff_id = ""; // # 销售人员id
      }
      let url = "";
      if (this.$cookies.get("agent_company_name") === null) {
        url = "/lufish_sale/v1/create_sale_deal/";
      } else {
        // agent_company_name不为空时，走这个在obj里面添加update_client对象
        if (
          this.title == "提交" &&
          ((this.$cookies.get("auth_grade") == 20 &&
            this.$cookies.get("agent_company_name")) ||
            (this.$cookies.get("auth_grade") == 80 &&
              this.$cookies.get("agent_company_name")))
        ) {
          obj.update_client = {
            industry: this.industry[this.industry.length - 1],
            company_place: this.company_place[this.company_place.length - 1],
            company_name: this.company_names.replace(/\s+/g, ""),
          };
        }
        if (this.from.agent_money_back) {
          obj.create_data.agent_money_back = this.from.agent_money_back;
        }

        // obj.business_license_img = this.license;
        // 24猎代理商
        if (
          this.$cookies.get("auth_grade") == 80 &&
          this.$cookies.get("parent_agent_id") == null
        ) {
          obj.business_license_img = this.license;
          url = "/lufish_sale/v1/create_sale_deal/";
        }
        // 24猎省代下的代理商
        else if (
          this.$cookies.get("auth_grade") == 80 &&
          this.$cookies.get("parent_agent_id") != null
        ) {
          obj.business_license_img = this.license;
          obj.create_data.province_agent_money_back =
            this.from.agent_money_back;
          delete obj.create_data.business_license_img;
          url = "/lufish_sale/v1/province_create_sale_deal/";
        }
        // 省代
        else if (this.$cookies.get("auth_grade") == 90) {
          obj.business_license_img = this.license;
          url = "/lufish_sale/v1/create_sale_deal/";
        }
        //其他人员
        else {
          obj.create_data.business_license_img = this.license;
          obj.business_license_img = this.license;
          url = "/lufish_sale/v1/agent_create_deal/";
        }
      }
      this.is_admin_deal_list = true;
      require("post", url, obj).then((res) => {
        console.log("123123123");
        console.log(res);
        if (res.code == 0) {
          this.is_admin_deal_list = false;
          console.log(res);
          this.$message.success("提交成功");
          this.init(this.page, this.tag_name);
          this.is_submit = false;
          this.from = {};
          this.imgArr = [];
          this.imgData = [];
          this.company_place = [];
          this.industry = [];
          this.paymentData = "";
          this.paymentArr = "";
          this.success_agent_pArr = "";
          this.success_agent_pData = "";
          this.success_P_pArr = "";
          this.success_P_pData = "";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //提交按钮涉及的事件结束
    //审核按钮
    shenHe(data) {
      require("post", "/lufish_sale/v1/check_deal/", {
        deal_id: this.keHuid,
        is_money_back: data,
        check_remarks: this.textarea,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          console.log(res);
          this.$message.success("提交成功");
          this.init(this.page, this.tag_name);
          this.is_reject = false;
          this.textarea = "";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    examine(row) {
      this.keHuid = row.deal_id;
      console.log(row.deal_id);
      this.is_reject = true;
    },

    //驳回按钮
    reject() {
      this.is_reject = true;
    },

    //弹窗关闭
    handleClose() {
      this.from = {};
      this.imgArr = [];
      this.imgData = [];
      this.paymentData = [];
      this.paymentArr = [];
      this.license = "";
      // 展示图片变量
      this.imageUrl = "";
      this.is_submit = false;
      this.is_reject = false;
    },
    //初始化
    init(page, status) {
      let url = "";
      if (this.$cookies.get("auth_grade") == 80) {
        url = "/lufish_sale/v1/agent_deal_list/";
      } else if (this.$cookies.get("auth_grade") == 90) {
        url = "/lufish_sale/v1/province_agent_deal_list/";
      } else {
        url = "/lufish_sale/v1/deal_list/";
      }
      // console.log(this.$cookies.get('auth_grade'))
      require("post", url, {
        page,
        deal_status: status,
        // sale_people_id: sale_people_id
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.tableData = [];
          res.data.deal_data.map((element) => {
            if (!element.place_name) {
              console.log(1545345);
              element.place_name = { city_name: "", district_name: "" };
            }
            if (this.$cookies.get("auth_grade") >= 80) {
              console.log("代理商下销售");
              element.agent_money_back = element.agent_money_back;
              element.sale_people_name = element.city_agent_person_name;
            }
            return element;
          });
          this.tableData = res.data.deal_data;
          this.total = res.data.deal_count;
          this.loading = false;
          console.log(
            this.tableData[0].agent_money_back,
            this.tableData[0].province_agent_money_back
          );
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.url_Api = url_Api;
    this.init(0, 0);
    //is_add:0  为没有不限  或者为有不限
    require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
      console.log(res);
      if (res.code == 0) {
        this.place_list = res.data;
      }
    });
    axios.get("/static/json/industry.json").then((res) => {
      this.industry_data = res;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$cookies.get("agent_company_name") == null) {
      this.place_props = {
        value: "value",
        label: "label",
        children: "children",
      };
    } else {
      this.place_props = {
        value: "value",
        label: "label",
        children: "children",
      };
    }
    if (this.$cookies.get("agent_company_name") != null) {
      require("post", "/lufish_sale/v1/agent_city_json/", {}).then((res) => {
        console.log(res);
        this.region_options = res.data;
        this.place_data = res.data;
      });
    } else {
      require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
        this.region_options = this.region_options.concat(res.data);
        this.place_data = res.data;
      });
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.bill_of_lading {
  position: relative;
  width: calc(100% - 209px);
  left: 181px;
  top: 68px;
  padding: 14px;
  min-height: 80vh;
  background: #fff;
}
.page {
  padding: 12px 0;
  text-align: right;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 120px;
  text-align: center;
  position: relative;
  /* padding-top: 100px; */
  top: 0px;
  border: #8c939d dashed 1px;
  border-radius: 5px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 30px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
.hideUpload /deep/ .el-upload {
  display: none; /* 上传按钮隐藏 */
}
.scopeDiv {
  width: 100%;
  /* display: flex; */
}
.scopeDiv > div {
  float: left;
  padding: 0 6px;
  overflow: hidden;
  text-align: center;
  margin-bottom: 10px;
  border-right: 2px solid rgb(233, 233, 233);
}
.scopeDiv > div:last-child {
  border-right: none;
}
.scopeDiv > div > p {
  padding: 6px;
  margin: 0;
  font-size: 12px;
  color: #3b3b3b;
}
.scopeDiv > div > .D_div {
  display: inline-block;
  width: 80px;
  line-height: 80px;
  text-align: center;
  background: #f5f7fa;
  color: #c0c4cc;
  /* float: left; */
}
.detail_info,
.detail_info > div,
.nav_left,
.nav_right,
.rl_flex {
  height: 100%;
}

.detail_info {
  position: relative;
}
.record {
  margin-bottom: 10px;
}

.btns .el-button {
  float: right;
  margin-top: 5px;
}

.nav_title {
  padding: 16px 24px;
  border-bottom: 1px solid #e4e9ed;
  display: flex;
}

.iconLC_icon_close_fill_circle {
  font-size: 24px;
  color: #3d76f7;
  position: absolute;
  top: 6px;
  left: 2px;
  cursor: pointer;
}

.nav_title > div {
  margin-left: 12px;
}

.rl_flex {
  display: flex;
}

.nav_left {
  width: 684px;
  border-right: 1px solid #e4e9ed;
}
.nav_left > div {
  padding: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e9ed;
}

.over_title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: #333;
}

.half_fl {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.pagination {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.pagination div {
  color: #aaa;
  font-size: 15px;
}

.status_box {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  border-radius: 16px;
  position: relative;
}

.status_iter {
  display: flex;
  justify-content: space-between;
}

.status_item {
  display: flex;
  justify-content: center;
}

.status_color {
  color: #3d76f7;
}

.cir.status_back,
.line_item.status_back {
  background: #3d76f7;
}
.cir_item {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
}
.cir_item img {
  height: 24px;
  width: 24px;
}

.cir:hover,
.status_item .title:hover {
  cursor: pointer;
}
.line_iter {
  margin-top: 10px;
  background: #f5f6fa;
  line-height: 32px;
  height: 32px;
  overflow: hidden;
  width: 100%;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
}

.line_item {
  position: absolute;
  height: 10px;
  width: 140px;
  background: #e5e7ee;
  left: 23px;
  top: 10px;
}

.cir {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: #e5e7ee;
  color: #3d76f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.half_fl .title {
  width: 92px;
}

.half_fl .cont {
  color: #333;
  width: 200px;
  height: 32px;
  line-height: 32px;
}

.contclass {
  display: flex;
}

.contclass .el-select {
  width: 60px;
  margin-right: 10px;
}

.half_fl > div {
  align-items: center;
  display: flex;
  width: 50%;
  margin-bottom: 16px;
  font-size: 14px;
  color: #999;
}

.nav_left > div:last-child {
  border-bottom: none;
}

.nav_right {
  /* width: calc(100% - 684px); */
  width: 440px;
  padding: 16px;
  box-sizing: border-box;
  font-size: 14px;
}

.rec_box {
  /* border:1px red solid; */
  max-height: calc(100vh - 250px);
  margin-top: 60px;
  overflow-y: auto;
}

.rec_box::-webkit-scrollbar {
  width: 4px;
}
.rec_box::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.rec_box .item {
  margin-top: 24px;
  font-size: 14px;
  line-height: 22px;
}

.rec_box .item_flex {
  display: flex;
  justify-content: space-between;
}

.com_name {
  color: #999;
  width: 35%;
}

.item_grow {
  color: #999;
}

.follow_detail {
  color: #333;
}

.follow_del {
  float: right;
  margin-top: -10px;
  cursor: pointer;
  color: #333;
}

.tab_name {
  display: flex;
  flex-wrap: wrap;
  min-height: 50px;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/bill_of_lading.vue